import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { MyHttpClient } from '../../http-client.service';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CustomerInvoiceReceiptRequestsService {
  server = environment.server;

  constructor(private http: MyHttpClient) {}

  raiseBulkInvoiceReceiptRequest(customerId: string, from: number, to: number, email?: string) {
    const url = `${this.server}/api/bulkInvoiceReceiptRequest/${customerId}`;
    const body: any = { from, to };
    if (email) body.email = email;
    return this.http.post(url, body).pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    return throwError(error);
  }
}


